import { withErrorBoundary } from 'shared'
import { Backend }           from 'base'
import { TopLevelPage }      from 'ui'
import { useEffect, useState } from 'react'
import useForceUpdate from 'hooks/useForceUpdate'

const SquareCardEditor = () => {
  // State
  const [state, setState] = useState({})

  // Consts

  // Hooks
  useEffect(() => {
    setupSquarePayment()
  }, [])

  // Custom Methods
  const forceUpdate = useForceUpdate()

  const saveCardWithBackend = async (nonce) => {
    try {
      setState({ ...state, saving: true })
      console.info('Saving card nonce:', nonce)
      let apiResult = await Backend.post("/profile/square/credit_cards", { nonce })
      console.info('API result:', apiResult)
      localStorage.rlHasCard = true
      setState({ ...state, done: true, saving: false })
      forceUpdate()
    } catch (err) {
      console.warn("Stripe or API error", err)
      setState({ ...state, success: false, saving: false })
    }
  }

  const setupSquarePayment = async () => {
    const squarePayment = Square.payments(application.squareApplicationId, null)
    const card = await squarePayment.card()
    await card.attach('#card-container')
    let eventHandler = async (event) => {
      event.preventDefault();
      try {
        const result = await card.tokenize();
        if (result.status === 'OK') {
          saveCardWithBackend(result.token)
        }
      } catch (e) {
        console.error(e);
      }
    };
    const cardButton = document.getElementById('card-button');
    cardButton.addEventListener('click', eventHandler);
  }

  if (state.done)
    return <Redirect to="/settings/payment" />

  return (
    <TopLevelPage className="SquarePayment row">
      <form id="form-container">
        <div id="card-container"></div>
        <button id="card-button" className="button-credit-card" type="button">
          Save Card
        </button>
        <p className="text-center mt-2">
          or <Link className="ui-btn ui-default" to="/settings/payment">Cancel</Link>
        </p>
      </form>
    </TopLevelPage>
  )
}

export default withErrorBoundary(SquareCardEditor)
